import gql from 'graphql-tag';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({ components: {} })
export default class SuggestionsLists extends Vue {
  @Prop() public projectId!: string;

  public readonly query = gql`
    query($projectId: ID!) {
      suggestionsListForProject(projectId: $projectId) {
        id
        name
        createdAt
        bookshop {
          name
        }
      }
    }
  `;

  public get queryVariables() {
    return {
      projectId: this.projectId,
    };
  }
}
